<template>
  <ChatModal
    :name="modalName"
    :title="$t('blogProfileTitle')"
    @before-open="beforeOpen"
  >
    <div v-if="blog" slot="default" :class="$style.container">
      <div :class="$style.block">
        <div :class="$style.label">{{ $t('blog.name') }}</div>
        <div>{{ blog.blogInfoDisplay.name }}</div>
      </div>
      <div :class="$style.block">
        <div :class="$style.label">{{ $t('blog.description') }}</div>
        <div>{{ blog.blogInfoDisplay.description }}</div>
      </div>
      <div v-if="category" :class="$style.block">
        <div :class="$style.label">{{ $t('category') }}</div>
        <div>{{ category }}</div>
      </div>
      <div v-if="!blog.isHideOwner" :class="$style.block">
        <div :class="$style.label">{{ $t('blogOwner') }}</div>
        <div v-if="blog.owner" @click="showProfile" :class="$style.owner">
          <Avatar :user="blog.owner" :size="44" />
          <div :class="$style.ownerName">{{ blog.owner.displayName }}</div>
        </div>
      </div>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from './ChatModal'
import { mapActions, mapGetters } from 'vuex'
import { camelCase } from 'lodash'
import Avatar from '@/components/Avatar'

export default {
  name: 'blog-profile',
  components: {
    ChatModal,
    Avatar
  },
  data () {
    return {
      modalName: 'blog-profile',
      shortId: null,
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    },
    lang () {
      return this.$i18n.locale
    },
    ...mapGetters({
      categories: 'entities/blogCategories/list',
      blogById: 'entities/blogs/getBlog'
    }),
    category () {
      if (!this.blog || !this.blog.category) return
      const locale = camelCase(this.$i18n.locale) // zhHans
      return this.blog.category[locale] || this.blog.category[this.$i18n.fallbackLocale]
    },
    blog () {
      return this.blogById(this.shortId)
    }
  },
  methods: {
    beforeOpen ({ params: { shortId } }) {
      this.shortId = shortId
      this.fetchByShortId(shortId)
    },
    ...mapActions('entities/blogs', {
      fetchByShortId: 'fetchByShortId'
    }),
    showProfile () {
      this.$modal.hide(this.modalName)
      this.$modal.show('profile', {
        userId: this.blog.ownerId,
        onClose: () => {
          this.$modal.show(this.modalName, { shortId: this.shortId })
        }
      })
    }
  }
}
</script>

<style lang="scss" module>
.container {
  padding: 14px 30px 0;
}
.block {
  border-bottom: 1px solid $border-color;
  padding: 10px 0;
}
.label {
  color: $text-mid;
  margin-bottom: 4px;
}
.owner {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.ownerName {
  margin-left: 10px;
  font-size: 16px;
  color: $text-colored;
}
</style>
